module.exports = __webpack_public_path__ + "img/course_review2.96ddc4d0.png";